var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.renderFlag)?_c('PieChart',{attrs:{"options":_vm.options,"chart-data":_vm.chartDataProcessed}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }